import React from 'react';
import { Quote, Info } from 'lucide-react';
import { SizeSpacingPanel, ColorsFontsPanel } from '../common/BlockStyleSettings';
import { BLOCK_FEATURES } from '../common/commonDefaults';

const EndorsementWallEditor = ({ block, onChange, theme, hideStylePanels }) => {
  const { content } = block;

  const handleChange = (field, value) => {
    onChange({ [field]: value });
  };

  const handleStyleChange = (styleUpdates) => {
    onChange({ style: { ...(content.style || {}), ...styleUpdates } });
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-xs font-medium text-gray-400 mb-1">Section Heading</label>
        <input
          type="text"
          value={content.heading || ''}
          onChange={(e) => handleChange('heading', e.target.value)}
          className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#749555]"
          placeholder="Endorsements"
        />
      </div>

      <div className="flex items-start gap-2.5 p-3 bg-blue-500/10 border border-blue-500/20 rounded-lg">
        <Info size={14} className="text-blue-400 flex-shrink-0 mt-0.5" />
        <div className="text-xs text-blue-300 leading-relaxed">
          <span className="font-medium">Custom block.</span> Endorsements are managed via the Admin dashboard
          (Endorsements tab). Submissions come through the private endorsement link.
        </div>
      </div>

      <div className="flex items-center gap-2 text-xs text-gray-500">
        <Quote size={12} />
        <span>Endorsement Wall (Premium Custom Block)</span>
      </div>

      {!hideStylePanels && (
        <>
          <SizeSpacingPanel
            style={content.style || {}}
            onChange={handleStyleChange}
            features={BLOCK_FEATURES['endorsement-wall'] || ['heading', 'colors', 'spacing']}
          />
          <ColorsFontsPanel
            style={content.style || {}}
            onChange={handleStyleChange}
            features={BLOCK_FEATURES['endorsement-wall'] || ['heading', 'colors', 'spacing']}
            theme={theme || {}}
            blockType="endorsement-wall"
          />
        </>
      )}
    </div>
  );
};

export default EndorsementWallEditor;
